module.exports = __webpack_public_path__ + "static/media/Car.promo.7c188964.svg";